(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["responsive-image-gallery"] && !Shopify.designMode) return;
  try {
    
(function() {
  var root = document.querySelector('.ig-{{ gid }}');
  if (!root || !root.classList.contains('is-mobile-slider')) return;

  var grid = root.querySelector('[data-grid]'); if (!grid) return;

  var autoplay = root.dataset.autoplay === 'true';
  var interval = parseInt(root.dataset.interval || '3500', 10);
  var showDots = root.dataset.showDots === 'true';
  var showArrows = root.dataset.showArrows === 'true';

  var controls = root.querySelector('[data-controls]');
  var dotsWrap = root.querySelector('[data-dots]');
  var prevBtn = root.querySelector('[data-prev]');
  var nextBtn = root.querySelector('[data-next]');

  function isMobile(){ return window.matchMedia('(max-width: 749px)').matches; }
  function colsMobile(){ return parseInt('{{ section.settings.columns_mobile }}', 10) || 2; }
  function perPage(){ return Math.max(1, colsMobile()); }
  function pageCount(){ return Math.max(1, Math.ceil(grid.children.length / perPage())); }

  function pageIndexFromScroll(){
    var per = perPage(), total = pageCount();
    var left = grid.scrollLeft, best = 0, bestDist = Infinity;
    for (var i=0;i<total;i++){
      var idx = Math.min(grid.children.length - 1, i*per);
      var l = grid.children[idx].offsetLeft;
      var d = Math.abs(left - l);
      if (d < bestDist){ bestDist = d; best = i; }
    }
    return best;
  }

  function goToPage(p){
    var per = perPage();
    var idx = Math.min(grid.children.length - 1, p * per);
    var el = grid.children[idx]; if(!el) return;
    grid.scrollTo({ left: el.offsetLeft, behavior: 'smooth' });
    activateDot(p);
    currentPage = p;
  }

  /* Build dots inside overlay */
  var dots = [];
  function buildDots(){
    if(!showDots || !dotsWrap) return;
    var total = pageCount();
    dotsWrap.innerHTML = '';
    dots = [];
    for (var i=0;i<total;i++){
      var dot = document.createElement('span');
      dot.className = 'ig-dot' + (i===0 ? ' is-active' : '');
      dot.dataset.index = String(i);
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
  }
  function activateDot(p){
    if(!showDots || !dots.length) return;
    dots.forEach(function(d,i){ if(i===p) d.classList.add('is-active'); else d.classList.remove('is-active'); });
  }

  /* Arrows */
  function next(){ var total = pageCount(); goToPage( (currentPage+1) % total ); }
  function prev(){ var total = pageCount(); goToPage( (currentPage-1+total) % total ); }
  if(showArrows && prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); prev(); });
  if(showArrows && nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); next(); });

  if(showDots && dotsWrap){
    dotsWrap.addEventListener('click', function(e){
      var dot = e.target.closest('.ig-dot'); if(!dot) return;
      e.preventDefault();
      goToPage(parseInt(dot.dataset.index || '0', 10));
    });
  }

  /* ---- Robust autoplay ----
     - Uses setInterval + currentPage state (not distance heuristic)
     - Pauses on touch/hover, on tab hidden, and when not mobile
     - If only 1 page, autoplay stops automatically
  */
  var timer=null, currentPage=0;

  function start(){
    stop();
    if(!autoplay || !isMobile()) return;
    if(pageCount() <= 1) return; /* nothing to slide */
    timer = setInterval(next, interval);
  }
  function stop(){ if(timer){ clearInterval(timer); timer=null; } }

  grid.addEventListener('mouseenter', stop);
  grid.addEventListener('mouseleave', start);
  grid.addEventListener('touchstart', stop, { passive:true });
  grid.addEventListener('touchend', start, { passive:true });

  grid.addEventListener('scroll', function(){
    // update page from natural swipes as well
    var p = pageIndexFromScroll();
    if(p !== currentPage){ currentPage = p; activateDot(p); }
  });

  document.addEventListener('visibilitychange', function(){ if(document.hidden) stop(); else start(); });

  function updateUI(){
    if(controls){
      controls.style.display = (isMobile() && (showDots || showArrows)) ? 'flex' : 'none';
    }
    buildDots(); activateDot(currentPage);
  }

  if('ResizeObserver' in window){
    new ResizeObserver(function(){ updateUI(); start(); }).observe(grid);
  } else {
    window.addEventListener('resize', function(){ updateUI(); start(); });
  }

  // init
  updateUI();
  currentPage = pageIndexFromScroll();
  activateDot(currentPage);
  start();
})();

  } catch(e) { console.error(e); }
})();
})();
